export default function exists() {
  return false;
}

exists.message = function message(value, options = {}) {
  return options.message || 'já está cadastrado';
};
